import { useState } from 'react';
export default function useParticipantAppInfo() {
  var _useState = useState({}),
      participantsInfo = _useState[0],
      setParticipantsInfo = _useState[1];

  return {
    participantsInfo: participantsInfo,
    setParticipantsInfo: setParticipantsInfo
  };
}